import React from "react";
import img1 from "../../../images/consulting/data-analytics-services-image1.jpg";
import img2 from "../../../images/consulting/data-analytics-services-image2.jpg";
import img3 from "../../../images/consulting/data-analytics-services-image3.jpg";
import img4 from "../../../images/consulting/data-analytics-services-image4.jpg";
import img5 from "../../../images/consulting/data-analytics-services-image5.jpg";
import img6 from "../../../images/consulting/data-analytics-services-image6.jpg";
import img7 from "../../../images/consulting/data-analytics-services-image7.jpg";
import img8 from "../../../images/consulting/data-analytics-services-image8.jpg";


const SERVICES = [
  "Digital Product Engineering",
  "Custom Software Development",
  "Enterprise Automation",
  "Dedicated Teams",
  "Rapid Prototyping",
  "Web Development",
];

const STATS = [
  {
    value: "82%",
    description: "of our clients increased ROI and decision speed in just 3 months with new data analytics solutions",
    color: "success",
  },
  {
    value: "52%",
    description: "higher data quality",
    color: "primary",
  },
  {
    value: "38%",
    description: "faster time to insights",
    color: "info",
  },
  {
    value: "Up to 8 hours",
    description: "per week saved via report automation",
    color: "success",
  },
  {
    value: "10–15%",
    description: "higher revenue compared to the gut-driven competitors",
    color: "warning",
  },
];

interface StatCardProps {
  value: string;
  description: string;
  color: string;
}

const StatCard: React.FC<StatCardProps> = ({ value, description, color }) => (
  <div className="col-12 col-md-6 col-lg-2 mb-4">
    <div className={`stat-card border-${color} shadow-sm h-100`}>
      <div className="card-body text-center">
        <h3 className={`text-${color} fw-bold`}>{value}</h3>
        <p>{description}</p>
      </div>
    </div>
  </div>
);

interface ServiceCardProps {
  service: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service }) => (
  <div className="col-12 col-md-6 col-lg-4 mb-3">
    <div className="services-card h-100">
      <h5>{service}</h5>
    </div>
  </div>
);

const DataAnalytics: React.FC = () => {
  return (
    <>
      {/* Intro Section */}
      <section className="container my-5">
        <h2 className="details-content-title mb-4">Data Analytics Services</h2>
        <p>
          Can't cross the chasm between messy, low-utility data and a single insightful source of
          truth? Instinctools gets you to the other side in one leap without skipping a beat in your
          everyday operations.
        </p>

        {/* Services */}
        <div className="row mt-4">
          {SERVICES.map((service) => (
            <ServiceCard key={service} service={service} />
          ))}
        </div>
      </section>

      {/* Stats Section */}
      <section className="container text-center mb-0  pt-35 ">
        <h2 className="mb-25 mt-3">Your data has answers. We help you see them</h2>
        <p className="mb-25 mt-3">
          Making the right decisions is not enough to grant your business a thriving future. You
          have to make them faster than your competitors do. And with Brain Machine.AI as your data
          analytics service provider, you'll hit the mark day to day.
        </p>

        <div className="row justify-content-center pt-45">
          {STATS.map((stat, index) => (
            <StatCard
              key={`${stat.value}-${index}`}
              value={stat.value}
              description={stat.description}
              color={stat.color}
            />
          ))}
        </div>
      </section>

            <div className="why-section  pt-10">
  <div className="container mb-25">
    <div className="text-center mb-5" data-aos="fade-up">
      <h2 className="section-title" style={{color: 'white'}}>Why Brain Machine.AI</h2>
    </div>
    
    <div className="row g-4">
      {/* Benefit 1 */}
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="0">
        <div className="benefit-item clickable">
          <h3 className="benefit-title-alt">Increase speed to market</h3>
          <div className="benefit-line">
            <span className="benefit-number-badge" style={{background: '#a4c639'}}>01</span>
          </div>
        </div>
      </div>

      {/* Benefit 2 */}
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
        <div className="benefit-item clickable">
          <h3 className="benefit-title-alt">Reduce development cost</h3>
          <div className="benefit-line">
            <span className="benefit-number-badge" style={{background: '#ffc107'}}>02</span>
          </div>
        </div>
      </div>

      {/* Benefit 3 */}
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
        <div className="benefit-item clickable">
          <h3 className="benefit-title-alt">Assure information security</h3>
          <div className="benefit-line">
            <span className="benefit-number-badge" style={{background: '#9c27b0'}}>03</span>
          </div>
        </div>
      </div>

      {/* Benefit 4 */}
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
        <div className="benefit-item clickable">
          <h3 className="benefit-title-alt">Get high-quality software</h3>
          <div className="benefit-line">
            <span className="benefit-number-badge" style={{background: '#f44336'}}>04</span>
          </div>
        </div>
      </div>

      {/* Benefit 5 */}
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
        <div className="benefit-item clickable">
          <h3 className="benefit-title-alt">Scale team up and down</h3>
          <div className="benefit-line">
            <span className="benefit-number-badge" style={{background: '#2196f3'}}>05</span>
          </div>
        </div>
      </div>

      {/* Link to Framework */}
      <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
        <div className="benefit-item clickable">
          <h3 className="benefit-title-alt" >
            Exclusive Delivery Framework
          </h3>
          <div className="benefit-line">
            <span className="benefit-number-badge" style={{background: '#2196f3'}}>06</span>
          </div>
        </div>
      </div>
    </div>
  </div>
            </div>
            <section className="clarification-call py-5">
      <div className="container mt-55">
         <h2 className="mb-25 pt-25 text-center w-75 mx-auto">Our data & analytics services meet you where you are and turn your data into a powerful business asset</h2>
        <p className="mt-3 mb-25 text-center w-75 mx-auto">
        We assess the volume, variety, and complexity of your data and identify your data analytics priorities to deliver a solution that best fits your business challenges and needs.
        </p>
        <div className="row align-items-center ">
          
          {/* LEFT CONTENT */}
          <div className="col-lg-6 mb-4 mb-lg-0 ">
            <div className="content-wrapper">
              <h2 className="fw-bold mb-4 mt-55 ">BI analytics</h2>

              <p className=" callp">
               If understanding what happened and why satiates your analytics craving, there’s no need to over-engineer data solutions. As your data analytics company, we collect, clean, and label your raw historical and real-time data to fully prepare it for a business intelligence tool.
              </p>
              <ul className="custom-list">
              <li>Custom dashboards</li>
              <li>Report automation</li>
              <li>Embedded analytics</li>
            </ul>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="col-lg-6 ">
            <div className="image-wrapper">
              <img
                src={img1}
                alt="Clarification call"
                  style={{ height:"full", borderRadius: "8px" }}
              />
            </div>
          </div>

        </div>

        <div className="row align-items-center pt-55 ">

          {/* LEFT */}
          <div className="col-lg-6 ">
            <div className="image-wrapper">
              <img
                src={img2}
                alt="Clarification call"
                  style={{ height:"full", borderRadius: "8px" }}
              />
            </div>
          </div>
          {/* RIGHT*/}
       
            <div className="col-lg-6 mb-4 mb-lg-0 ">
            <div className="content-wrapper">
              <h2 className="fw-bold mb-4 mt-45 ">Augmented analytics</h2>

              <p className=" callp">
               Static reports won’t cut it if you need to examine data from multiple angles. Our data engineers enable advanced analytics with AI algorithms at its core. With context-aware sentiment analysis and natural language querying, your teams will be able to turn massive data sets into actionable insights on demand, without waiting for analysts.
              </p>
              <ul className="custom-list">
              <li>Self-service analytics</li>
              <li>AI-driven data queries</li>
              <li>Smart report personalization</li>
            </ul>
            </div>
          </div>
        </div>
        
        <div className="row align-items-center pt-55">
          
          {/* LEFT CONTENT */}
          <div className="col-lg-6 mb-4 mb-lg-0 ">
            <div className="content-wrapper">
              <h2 className="fw-bold mb-4 mt-55 ">Agentic analytics</h2>

              <p className=" callp">
               Want to handle complex analytics tasks with no or minimal human input? We implement AI agents that analyze, interpret, and act on enterprise data, freeing you up for governance and big-picture thinking.
              </p>
              <ul className="custom-list">
              <li>Automated multi-step analysis</li>
              <li>Intelligent decision support</li>
              <li>Self-generated data insights and recommendations without you asking</li>
            </ul>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="col-lg-6 ">
            <div className="image-wrapper">
              <img
                src={img3}
                alt="Clarification call"
                  style={{ height:"full", borderRadius: "8px" }}
              />
            </div>
          </div>

        </div>
      </div>
            </section>

            <section className="clarification-call py-5">
      <div className="container mt-55">
         <h2 className="mb-25 pt-25 text-center w-75 mx-auto">Uncompromising data protection all the way through your analytics journey with Brain Machine</h2>
        <p className="mt-3 mb-25 text-center w-75 mx-auto">
        Data is the driving power of your business, and with us as your data analytics service provider, you stay in complete control of it.
        </p>
      
        <div className="row align-items-center pt-55 ">

          {/* LEFT */}
          <div className="col-lg-6 ">
            <div className="image-wrapper">
              <img
                src={img4}
                alt="Clarification call"
                  style={{ height:"full", borderRadius: "8px" }}
              />
            </div>
          </div>
          {/* RIGHT*/}
       
            <div className="col-lg-6 mb-4 mb-lg-0 ">
            <div className="content-wrapper">
              <p className=" callp">
              We follow a well-calibrated information security framework to ensure you get all the benefits of data analytics without risking the privacy of your data. Our unwavering focus on physical, technical, organizational, legal, and ethical data protection implies:
              </p>
              <ul className="custom-list">
              <li>Secure software development lifecycle</li>
              <li>Secure infrastructure</li>
              <li>Personal data protection</li>
              <li>Information security procedures</li>
              <li>Intellectual property protection</li>
            </ul>
            </div>
          </div>
        </div>
    
      </div>
            </section>

             <section className="clarification-call py-5">
      <div className="container mt-55">
         <h2 className="mb-25 pt-25 text-center w-75 mx-auto">Get the most from your data with our data engineering add-ons
         </h2>
        <p className="mt-3 mb-25 text-center w-75 mx-auto">
        Seamless migrations, AI-ready augmentation, compelling visual storytelling… We put your data and analytics solutions to work beyond a well-designed architecture.
        </p>
        <div className="row align-items-center ">
          
          {/* LEFT CONTENT */}
          <div className="col-lg-6 mb-4 mb-lg-0 ">
            <div className="content-wrapper">
              <h2 className="fw-bold mb-4 mt-55 ">Data migration</h2>

              <p className=" callp">
               Switching tools or systems shouldn’t slow you down. From Excel to BI, from one BI tool to another, from BI to augmented or agentic analytics — our data engineers smooth out the bumps on your way to a new data analytics system. As part of our data and analytics services, we review your data sources, transform data to ensure it fits the new storage, and outline a data migration strategy with data security and business value in mind.
              </p>
              <ul className="custom-list">
              <li>Migrations during off-peak hours to minimize the impact on your business performance</li>
              <li>Built-in data quality checks for high-quality output</li>
              <li>Streamlined metadata management for better data discoverability and governance</li>
              <li>Optimized database schema for more efficient storage, retrieval, and processing of data</li>
              <li>SKPI-aligned data mapping</li>
            </ul>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="col-lg-6 ">
            <div className="image-wrapper">
              <img
                src={img5}
                alt="Clarification call"
                  style={{ height:"full", borderRadius: "8px" }}
              />
            </div>
          </div>

        </div>

        <div className="row align-items-center pt-55 ">

          {/* LEFT */}
          <div className="col-lg-6 ">
            <div className="image-wrapper">
              <img
                src={img6}
                alt="Clarification call"
                  style={{ height:"full", borderRadius: "8px" }}
              />
            </div>
          </div>
          {/* RIGHT*/}
       
            <div className="col-lg-6 mb-4 mb-lg-0 ">
            <div className="content-wrapper">
              <h2 className="fw-bold mb-4 mt-45 ">Data augmentation</h2>

              <p className=" callp">
               Want to capitalize on AI-based data analytics but you’re short on training data to train large language models or dealing with privacy-sensitive datasets? Our ML engineers generate synthetic, anonymous data to enrich your existing set without compromising security or accuracy.
              </p>
              <ul className="custom-list">
              <li>Providing enough high-quality data to squeeze maximum value out of AI-driven analytics</li>
              <li>Preventing model overfitting</li>
              <li>Improving the overall performance and accuracy of large language models’ predictions</li>
              <li>Strengthen data privacy by design</li>
            </ul>
            </div>
          </div>
        </div>
        
        <div className="row align-items-center pt-55">
          
          {/* LEFT CONTENT */}
          <div className="col-lg-6 mb-4 mb-lg-0 ">
            <div className="content-wrapper">
              <h2 className="fw-bold mb-4 mt-55 ">Data visualization</h2>

              <p className=" callp">
               Crafting a custom data visualization on an open-source tech stack or customizing platform-based solutions  our BI engineers excel at both. They create interactive dashboards tailored to your KPIs and workflows, so that you can get the story behind the numbers and act on the insights faster. Zoom out for strategy or zoom in for detail  your options are limitless with Barin Machine.AI as your data analysis company.
              </p>
              <ul className="custom-list">
              <li>Role-based data access</li>
              <li>Granular vs. high-level insights</li>
              <li>No-code drill-downs for non-tech users</li>
            </ul>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="col-lg-6 ">
            <div className="image-wrapper">
              <img
                src={img7}
                alt="Clarification call"
                  style={{ height:"full", borderRadius: "8px" }}
              />
            </div>
          </div>

        </div>

        <div className="row align-items-center pt-55 ">

          {/* LEFT */}
          <div className="col-lg-6 ">
            <div className="image-wrapper">
              <img
                src={img8}
                alt="Clarification call"
                  style={{ height:"full", borderRadius: "8px" }}
              />
            </div>
          </div>
          {/* RIGHT*/}
       
            <div className="col-lg-6 mb-4 mb-lg-0 ">
            <div className="content-wrapper">
              <h2 className="fw-bold mb-4 mt-45 ">Data analytics modernization</h2>

              <p className=" callp">
               An outmoded, underperforming, or inaccurate analytics leads to messy, slow, and error-prone decision-making. Take a lean road to an up-to-date analytics solution with a trusted analytics company.
              </p>
              <ul className="custom-list">
              <li>New-gen analysis methods</li>
              <li>Better storage solutions</li>
              <li>AI-powered insights</li>
            </ul>
            </div>
          </div>
        </div>
      </div>
            </section>



    </>
  );
};

export default DataAnalytics;